import { Button, Container, Heading, HStack, Image, Input, Stack, Text, VStack } from '@chakra-ui/react'
import React,{useEffect, useState} from 'react'
import { toast } from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { getAllCourses } from '../../redux/actions/course'
import { addToPlaylist } from '../../redux/actions/user'

const Course=({views,title,imageSrc,id,addToPlaylistHandler,creator,description,lectureCount})=>{
    return (
        <VStack className='course' alignItems={['center','flex-start']}>
            <Image src={imageSrc} boxSize='60' objectFit={'contain'}/>
            <Heading textAlign={['center','left']} maxW='200px' font-family='SourceSansPro' noOfLines={3} children={title} size={'sm'}/>
            <Text noOfLines={2} children={description}/>
            <HStack>
                <Text fontWeight={'bold'} textTransform='uppercase' children={'Creator:'}/>
                <Text fontFamily={'body'} textTransform='uppercase' children={creator}/>
            </HStack>
            <Heading textAlign={'center'} size='xs' children={`Lectures- ${lectureCount}`} textTransform='uppercase' />
            <Heading textAlign={'center'} size='xs' children={`Views- ${views}`} textTransform='uppercase' />
            <Stack direction={['column','row']} alignItems='center'>
                <Link to={`/course/${id}`}>
                    <Button colorScheme={'yellow'}>Start learning</Button>
                </Link>
                <Button variant={'outline'} colorScheme={'yellow'} onClick={()=>addToPlaylistHandler(id)}>Add to Playlist</Button>
            </Stack>
        </VStack>
    )
}

const Courses = () => {
    const [keyword,setKeyword] = useState();
    const [category,setCategory]=useState();
    const categories = [
        "web dev" , "ml","cp" ,"app dev" ,"dsa"
    ]

    const {loading,courses,error,message} = useSelector(state=>state.courses)
    const dispatch = useDispatch();
    const addToPlaylistHandler=(courseId)=>{
        // console.log('added')
        dispatch(addToPlaylist(courseId));
    }
    useEffect(() => {
     dispatch(getAllCourses(category,keyword));
     if(error){
        toast.error(error);
        dispatch({type:'clearError'})
     }
     if(message){
        toast.success(message);
        dispatch({type:'clearMessage'})
     }
    }, [category,keyword,dispatch,error]);
    
  return (
    <Container minH={'95vh'} maxW='container.lg' paddingY={'8'}>
        <Heading children="All Courses" m={'8'} />
        <Input value={keyword} onChange={e=> setKeyword(e.target.value)} placeholder='Search a course ...' type={'text'} focusBorderColor='yellow.500'/>
        <HStack overflow={'auto'} paddingY='8' >
            {
                categories.map((item,index)=>(
                    <Button key={index} onClick={()=>setCategory(item)} minW={'60'}>
                        <Text children={item} />
                    </Button>
                ))
            }
        </HStack>
        <Stack 
            direction={['column','row']}
            flexWrap='wrap'
            justifyContent={['flex-start','space-evenly']}
            alignItems={['center','flex-start']}
        >
            {
                courses && courses.map((item,)=>(
                <Course
                key={item._id}
                title={item.title}
                description={item.description}
                views={item.views}
                imageSrc={'https://upload.wikimedia.org/wikipedia/en/c/cb/Monkey_D_Luffy.png'}
                id={item._id}
                creator={item.createdBy}
                lectureCount={item.numOfVideos}
                addToPlaylistHandler={addToPlaylistHandler}
                />
                ))
                
                
            }
        </Stack>
    </Container>
  )
}

export default Courses